import $ from 'jquery';

class Carousel {
    constructor(id) {
        this.carousel = $(id);
        this.bullets = this.carousel.find(".carousel-bullet");
        this.items = this.carousel.find(".carousel-open");
        this.length = this.items.length;

        if(this.carousel) {
            this.events();
        }
    }

    events() {
        var timer = setInterval(this.auto_slide.bind(this), 3000);
        this.bullets.on('click', () => {
            clearInterval(timer);
            timer = setInterval(this.auto_slide.bind(this), 3000);
        });
    }

    auto_slide() {
        for (var i = 0; i < this.length; i++) {
            if(this.items.eq(i).prop('checked') == true) {
                this.items.eq(i).prop('checked', false);
                if(i+1 >= this.length) {
                    this.items.eq(0).prop('checked', true);
                } else {
                    this.items.eq(i+1).prop('checked', true);
                }
                break;
            }
        }
    }

}

export default Carousel;